import { Component, OnInit, ElementRef, ViewChild, Input, AfterViewInit } from '@angular/core';
import { Chart } from 'chart.js';
import { MatDialog } from '@angular/material/dialog';
import { DashboardTurnsBestDesksZoomCardComponent } from '../dashboard-turns-best-desks-zoom-card/dashboard-turns-best-desks-zoom-card.component';

@Component({
  selector: 'app-dashboard-turns-best-desks-card',
  templateUrl: './dashboard-turns-best-desks-card.component.html',
  styleUrls: ['./dashboard-turns-best-desks-card.component.scss']
})
export class DashboardTurnsBestDesksCardComponent implements OnInit, AfterViewInit {

  @ViewChild('bestDesks', { static: false }) bestDesksRef: ElementRef;
  @Input() data;
  @Input() colors;
  @Input() title;
  ctx;
  myChart;

  constructor(private dialog: MatDialog) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.ctx = this.bestDesksRef.nativeElement.getContext('2d');
    this.renderChart(this.data);
  }

  public statZoom() {
    this.dialog.open(DashboardTurnsBestDesksZoomCardComponent, { data: { data: this.data, title: this.title, colors: this.colors } } );
  }

  private renderChart(data) {
    if (this.myChart) {
      this.myChart.destroy();
    }
    const labels = data.map(d => d['deskName']);
    const counts = data.map(d => d['counter']);
    const colors = this.colors.slice(0, counts.length);
    const hoverColors = colors.map(c => c = c + 'EE');

    this.myChart = new Chart(this.ctx, {
      type: 'bar',
      data: {
        datasets: [
          {
            data: counts,
            backgroundColor: colors,
            hoverBackgroundColor: hoverColors
          },
        ],
        labels: labels
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            gridLines: {
              display: true,
              color: '#eeeeee',
              drawBorder: false
            },
            ticks: {
              display: false,
              beginAtZero: true
            }
          }],
          xAxes: [{
            gridLines: {
              display: false,
              tickMarkLength: 10
            },
            ticks: {
              fontSize: 10,
              fontColor: '#aaaaaa'
            }
          }]
        },
        legend: {
          display: false,
        }
      },
      plugins: [{
        id: 'total',
        afterDraw: (chart) => {
          if (!(data && (data.length > 0))) {
            const width = chart.width;
            const height = chart.height;
            const ctx = chart.ctx;
            ctx.restore();
            const text1 = 'Not found';
            ctx.fillStyle = '#ffffff';
            ctx.fillRect(width / 2 - ctx.measureText(text1).width / 2 - 30, height / 2 - 65, ctx.measureText(text1).width + 60, 50);
            ctx.fillStyle = '#aaaaaa';
            ctx.font = '14px sans-serif';
            ctx.fillText(text1, width / 2 - (ctx.measureText(text1).width / 2), height / 2 - 40);
            ctx.save();
          }
        }
      }]
    });
  }

}
